import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {HomeHero} from "./home_hero";

export const homeHeroLoader = function (options = {}) {
    componentLoader(componentConfig(HomeHero, HomeHero.config.componentTypeKey, HomeHero.config.baseHtmlClass), options);
};
